<style>
#main__wrapper {
  height: 100%;
}
#addAttachmentsToObjects .v--modal-box.v--modal {
  min-height: 260px !important;
  min-width: 695px !important;
}
#addAttachmentsToObjects .modal__footer {
  display: none;
}
#addAttachmentsToObjects .v-tabs__div {
  width: 50% !important;
  max-width: none;
}
#addAttachmentsToObjects .v-tabs__slider-wrapper {
  width: 50% !important;
}
#addAttachmentsToObjects .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#addAttachmentsToObjects .complete-inspection__background:hover {
  cursor: pointer;
}
#addAttachmentsToObjects .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#addAttachmentsToObjects .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
</style>

<template>
  <div class="wrapper">
    <Modal
      modalName="addAttachmentsToObjects"
      title="Zaznacz obiekty i dodaj do nich załączniki"
      @opened="loadAttachments"
      @closed="closed()"
      @saved="assignAttachmentToObject"
      :buttons="['']"
    >
      <v-layout>
        <v-list
          subheader
          style="width: 100%"
          v-if="objects.length != 0"
        >
          <v-subheader class="font--primary">Lista zaznaczonych obiektów</v-subheader>
          <v-list-tile
            v-for="(object, index) in objects"
            :item="object"
            :key="object.object_id"
            style="border-bottom: 1px solid lightgrey"
          >
            <v-list-tile-content>
              <v-list-tile-title class="font--primary">Obiekt '{{object.full_name}}' - {{object.object_display_id}}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <span>
                <v-icon
                  depressed
                  fab
                  id="btn__hydrant--zoom"
                  @click="zoomToObject(object, index)"
                  title="Przybliż do obiektu"
                >zoom_in</v-icon>
                <v-icon
                  depressed
                  fab
                  class="table__btn--red"
                  id="btn__hydrant--remove"
                  @click="removeObject(object, index)"
                  title="Usuń obiekt"
                >delete</v-icon>
              </span>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-flex v-else>
          <v-subheader class="font--primary">Lista zaznaczonych obiektów</v-subheader>
          <p
            v-if="objects.length == 0"
            style="font-size: 12px; margin-bottom:20px"
          >Brak zaznaczonych obiektów. Kliknij przycisk poniżej, a następnie wskaż na mapie obiekt, do którego chciałbyś dodać załącznik.</p>
        </v-flex>
      </v-layout>
      <v-layout justify-center>
        <v-btn
          dark
          depressed
          small
          color="#304058"
          @click="selectNewObject"
          style="margin-bottom: 40px;"
        >Zaznacz nowy obiekt</v-btn>
      </v-layout>

      <v-tabs
        color="#2a579a"
        dark
        centered
        grow
        active-class="tab--active"
        :hide-slider="true"
        height="35"
        v-if="objects.length != 0"
      >
        <v-tab @click="changeActiveBookmark('uploadAtt')">Dodawanie załącznika z dysku</v-tab>
        <v-tab-item>
          <AddAttachment
            ref="childComponent"
            @confDialogOpened="triggerDialogAttach"
            @attachmentAdded="attachmentAdded"
            @sendingError="sendingError"
            :module="module"
            :objects="objects"
            :auto="true"
            :isAttachmentToObject="true"
          />
        </v-tab-item>
        <v-tab @click="changeActiveBookmark('addDb')">Dodanie załącznika z bazy danych</v-tab>
        <v-tab-item>
          <DatabaseAttachments />
        </v-tab-item>
      </v-tabs>
    </Modal>
  </div>
</template>

<script>
import Modal from "./Modal";
import AddAttachment from "./AddAttachment";
import DatabaseAttachments from "../viewer/table/attachments/DatabaseAttachments";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import includes from "lodash/includes";
import map from "lodash/map";
import each from "lodash/each";
import some from "lodash/some";
import find from "lodash/find";
import filter from "lodash/filter";
mixin(_, {
  includes,
  map,
  some,
  find,
  each,
  filter,
  chain
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    Modal,
    AddAttachment,
    DatabaseAttachments
  },
  data: () => ({
    objects: [],
    attachmentsWithoutObject: [],
    selected: [],
    isUploading: true,
    module: "addAttachmentsToObjects"
  }),
  computed: {
    map() {
      return this.$store.getters.getMap;
    },
    selectedLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(0);
    },
    attachmentsList() {
      return this.$store.getters.getAttachments;
    },
    layers() {
      const self = this;
      const layers = _.chain(
        self.map
          .getLayers()
          .item(2)
          .getLayers()
          .getArray()
      )
        .filter(layer =>
          _.includes(["water", "sewer"], layer.get("layer_type"))
        )
        .map(layer => ({
          key: layer.get("type"),
          instance: self.$root.createProxy(layer)
        }))
        .value();

      const app_layers = self.map.getLayers()
        .item(0)
        .getLayers()
        .getArray()
        .filter(
          layer => layer.get('type') == 'app_layer'
        )
        .map(layer => ({
          key: layer.get("name").split(":").pop(),
          instance: self.$root.createProxy(layer)
        })
        )


      return layers.concat(app_layers)
    }
  },
  methods: {
    closed() {
      this.objects = [];
      this.map.getViewport().style.cursor = "";
      this.$root.$emit("clearSelectionFeatures");
      this.$root.$emit("disableSelectionElement");
      this.selected = [];
      this.attachmentsWithoutObject = [];
      this.isUploading = true;
    },
    loadAttachments() {
      if(this.attachmentsWithoutObject.length == 0) {
        this.$store.dispatch("getAttachments").then(r => {
          if(r) {
            this.attachmentsWithoutObject = this.attachmentsList.data;
          }
        });
      }
    },
    changeActiveBookmark(attachmentUploadType) {
      this.isUploading = attachmentUploadType == "uploadAtt" ? true : false;
    },
    assignAttachmentToObject(data) {
      this.selected = data;
      if(this.selected.length < 1) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Nie wybrano obiektów"
        );
        return;
      }
      let payload;
      for(let oid of this.selected) {
        payload = {
          objects: _.map(this.objects, (object) => ({
            object_id: object.object_id,
            object_table: object.object_table,
            object_type: object.object_type,
          }))
        };
      }
      this.$store
        .dispatch("addAttachmentToObject", [oid.id, payload])
        .then(r => {
          if(r.status != 200) {
            this.$root.$emit(
              "showSnackbar",
              "red",
              `${r.data.message}`
            );
            return;
          } else {
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie dodano załącznik do zaznaczonych obiektów"
            );
          }
        });
      this.$modal.hide("addAttachmentsToObjects");
    },
    attachmentAdded() {
      this.$root.$emit(
        "showSnackbar",
        "success",
        "Pomyślnie dodano załącznik do zaznaczonych obiektów"
      );
    },
    sendingError() {
      this.$root.$emit(
        "showSnackbar",
        "red",
        "Wystąpił błąd podczas dodawania załącznika do zaznaczonych obiektów"
      );
    },

    removeObject(object, index) {
      this.objects.splice(index, 1);

      this.$store.commit("removeCurrentSelectedFeatures", [object.org_feature]); //usunięcie z listy zaznaczonych
      this.selectedLayer.getSource().removeFeature(object.org_feature.__value); //usunięcie podświetlania
    },
    zoomToObject(object, index) {
      const self = this;
      /*const layer = _.find(
        self.layers,
        layer => layer.key === object.object_table
      );
      if(!layer) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Nie znaleziono warstwy elemenu"
        );
        return;
      }

      let feature = undefined;
      if(layer.key == 'granice_dzialek') {

        feature = _.find(
          this.selectedLayer.getSource().getFeatures(),
          feature => feature.getId() === object.object_id && feature.get('nr_dzialka') != undefined
        );
      }
      else {
        feature = _.find(
          layer.instance.getSource().getFeatures(),
          feature => feature.getId() === object.object_id
        );
      }
      if(!layer) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Nie znaleziono elementu na warstwie"
        );
        return;
      }

      self.$root.$emit("zoomToGeometry", feature.getGeometry(), {});*/

      this.$root.$emit("zoomToFeature", object.org_feature.__value, {});
    },
    selectNewObject() {
      const self = this;
      //self.$modal.hide("addAttachmentsToObjects");
      self.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby wybrać obiekt"
      );
      self.map.getViewport().style.cursor = "crosshair";
      self.$root.$once("selectionElementCallback", featuresLayers => {
        //console.log(featuresLayers);
        _.each(featuresLayers, featuresLayer => {
          //przeleć po warstwach
          const features = featuresLayer.features_cluster.length > 0
            ? featuresLayer.features_cluster
            : featuresLayer.features;
          _.each(features, feature => {
            //przeleć po elementach warstwy
            const id = feature.getId();

            if(_.some(self.objects, object => object.object_id === id)) {
              return; //duplicat
            }

            const org_feature = self.$root.createProxy(feature);
            if(featuresLayer.layer.get('type') === 'app_layer') {
              self.objects.push({
                object_id: feature.getId(),
                object_table: featuresLayer.layer.get("name").split(":").pop(),
                object_type: "app_layers",
                full_name: featuresLayer.layer.get("full_name"),
                object_display_id: feature.get('nr_dzialka'),

                org_feature, //orginalny feature do usuwania i zoomu
              });
            } else {
              self.objects.push({
                object_id: feature.getId(),
                object_table: featuresLayer.layer.get("type"),
                object_type: "layers",
                full_name: featuresLayer.layer.get("full_name"),
                object_display_id: feature.getId(),

                org_feature, //orginalny feature do usuwania i zoomu
              });
            }

            self.$store.commit("addCurrentSelectedFeatures", [org_feature]); //dodanie do listy zaznaczonych
            self.selectedLayer.getSource().addFeature(feature); //dodanie podświetlania
          });
        });
        self.$forceUpdate();
        self.map.getViewport().style.cursor = "";
        //self.$modal.show("addAttachmentsToObjects");
      });
      self.$root.$emit("enableSelectionElement", {
        //wszystkie warstwy
        selected: false,
        multi: false
      });
    },

    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    }
  },
  mounted() {
    this.$root.$on('assignAttachmentToObject', this.assignAttachmentToObject)
  },
  created() {
    //console.log("AddAttachmentsToObjects", this);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/AddAttachmentsToObjects.vue